<template>
<v-container fluid class="pa-0" style="height: 100vh; background: #53aafb; background-image: url(https://wordpress.trackier.com/wp-content/uploads/2020/07/map.png);">
    <div v-if="load" class="w-h-50" style="background: #eff6fe; background-image: url(https://wordpress.trackier.com/wp-content/uploads/2020/07/map.png);">
        <div class="login-card-p">
            <v-card flat class="zoom-90 pa-12 pt-10 text-center" style="border-radius: 1rem !important">
                <div>
                    <img width="150" src="/images/logo1.png" alt="">
                </div>
                <br />
                <v-progress-circular indeterminate size="40" color="primary"></v-progress-circular>
            </v-card>
        </div>
    </div>
    <div v-else class="w-h-50" style="background: #eff6fe; background-image: url(https://wordpress.trackier.com/wp-content/uploads/2020/07/map.png);">
        <div v-if="isVerify" class="login-card-p">
            <div class="pa-5 d-flex justify-center align-center flex-column" flat>
                <v-img width="500" src="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/img/404.0a38972b.png">
                </v-img>
                <p class="display-1 grey--text text--darken-3 my-10" style="text-shadow: 1px 1px 1px #555">{{title}}</p>
                <v-btn class="px-10 font-weight-bold" color="primary" to="/">Back to Home</v-btn>
            </div>
        </div>
        <div v-else-if="isDone" class="login-card-p">
            <v-card width="100%" flat class="zoom-90" style="border-radius: 1rem !important">
                <v-row>
                    <v-col cols="12" sm="12" md="6">
                        <div class="px-10">
                            <br />
                            <br />
                            <v-img max-width="200" class="mx-auto" src="/images/logo1.png" lazy-src="/images/logo1.png" aspect-ratio="4" contain>
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                            <div class="px-md-6 pt-6">
                                <v-divider></v-divider>
                                <p style="margin-top: -13px; text-align: center;"><span class="pa-2 white caption grey--text">Reset your password</span></p>
                                <br />
                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <v-row>
                                        <v-col cols="12" class="py-0">
                                            <v-text-field v-model="passwords.password" :rules="[v => !!v || 'New Password is required']" :append-icon="passwardShow ? 'mdi-eye' : 'mdi-eye-off'" :type="passwardShow ? 'text' : 'password'" @click:append="passwardShow = !passwardShow" class="border-radius" label="New Password" outlined dense required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <v-text-field v-model="passwords.confirm_password" :rules="confirmPasswordRules.concat(passwordConfirmationRule)" type="password" class="border-radius" label="Re Enter" outlined dense required></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-card-actions class="px-0">
                                        <v-btn color="blue darken-1" block :loading="loading" @click="Change" class="px-4" dark>Change Password</v-btn>
                                    </v-card-actions>
                                </v-form>
                                <br />
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="d-none d-md-block">
                        <v-card-text class="pa-12">
                            <v-img width="80%" src="/images/password.jpg" lazy-src="/images/password.jpg" aspect-ratio="1" class="mx-auto grey lighten-2">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-card-text>
                    </v-col>
                </v-row>
            </v-card>
        </div>
        <div v-else class="login-card-p">
            <v-card flat class="zoom-90" style="border-radius: 1rem !important">
                <v-row>
                    <v-col cols="6" class="d-none d-md-block">
                        <div class="px-10">
                            <v-img src="/images/success.png" lazy-src="/images/success.png" aspect-ratio="1" class="grey lighten-2">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" class="pa-6 pb-0 d-flex align-center">
                        <div style="width: 100%">
                            <v-card-text class="title text-center">
                                <h4>{{title}}</h4><br>
                            </v-card-text>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </div>
    </div>
</v-container>
</template>

<script>
import {
    mapMutations,
    mapActions
} from 'vuex'
export default {
    data: () => ({
        passwords: {
            password: '',
            confirm_password: ''
        },
        passwardShow: false,
        transition: 'scale-transition',
        valid: false,
        load: true,
        loading: false,
        isVerify: true,
        skeleton: true,
        isDone: true,
        title: 'Invalid token',
        passwordRules: [v => !!v || "Password is required"],
        confirmPasswordRules: [v => !!v || "Password is required"]
    }),
    computed: {
        passwordConfirmationRule() {
            return () =>
                this.passwords.password === this.passwords.confirm_password || "Password must match";
        }
    },
    async mounted() {
        await this.verifyToken();
        setInterval(() => {
            this.load = false
        }, 500);
    },
    methods: {
        ...mapMutations(['SnackbarSuccess']),
        ...mapActions(['PostResponse', 'GetResponse']),
        async verifyToken() {
            try {
                let url = `/internal/v2/token-verify/${this.$route.params.token}`
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.title = data.message
                    this.isVerify = false
                    this.skeleton = false
                    this.isDone = true
                } else {
                    this.title = data.message
                    this.isVerify = true
                    this.skeleton = false
                    this.isDone = false
                }
            } catch (error) {
                let data = {
                    success: !error.response.data.success,
                    message: error.response.data.errors[0].message,
                    action: 'error'
                }
                this.SnackbarSuccess(data)
            }
        },
        async Change() {
            if (this.$refs.form.validate()) {
                this.loading = true
                if (this.passwords.password == this.passwords.confirm_password) {
                    this.passwords.token = this.$route.params.token
                    try {
                        let value = {
                            url: '/internal/v2/reset-password',
                            data: this.passwords
                        }
                        const data = (await this.PostResponse(value)).data
                        if (data.success) {
                            let time = 5
                            var setTime = setInterval(() => { 
                                if (time > 0){
                                    this.title = `Password changed successfully, redirecting you in ${--time} seconds...`
                                } else {
                                    this.$router.push('/')
                                    clearInterval(setTime)
                                }
                            }, 1000)
                            let msg = {
                                success: true,
                                message: data.message,
                                action: 'success'
                            }
                            this.SnackbarSuccess(msg)
                            this.title = data.message
                            this.isDone = false
                            this.loading = false
                        }
                    } catch (error) {
                        let data = {
                            success: !error.response.data.success,
                            message: error.response.data.errors[0].message,
                            action: 'error'
                        }
                        this.SnackbarSuccess(data)
                        this.loading = false
                    }
                } else {
                    let data = {
                        success: true,
                        message: 'Password no match',
                        action: 'error'
                    }
                    this.SnackbarSuccess(data)
                }
            }
        }
    },
}
</script>
<style scope>
    .w-h-50{
        width: 50%;
        height: inherit;
    }
    .login-card-p{
        position: absolute;
        top: 0;
        left: 15%;
        right: 15%;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    @media only screen and (max-width: 600px) {
        .login-card-p{
            left: 2%;
            right: 2%;
        }
    }
    .login-img{
        border-top-right-radius: 1rem; 
        border-bottom-right-radius: 1rem;
        display: inherit;
    }
</style>
